(() => {
  /**
   * Handle the awarding of modifiers
   */
  class ModifierAwardedPanel extends PIXI.Container {
    constructor() {
      super();

      this._modifierAssets = {
        boost: [],
        multi: [],
        respin: [],
      };

      this._currentBoost = null;

      this._modifierAwardedCompletePromise = null;
      this._modifierAwardedCompleteResolve = null;

      this._panelShowing = false;

      Reflex.registerEventHandler("orientationChange", this._orientationChange.bind(this));
    }

    /**
     * Set click to continue active
     */
    setActive() {
      this._pressStartBox.interactive = true;
      this._pressStartBox.visible = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = this.scaleOutPanel.bind(this);
    }

    /**
     * Initialise the class
     */
    initialise() {
      this.parent.visible = true;
      this._modifierAwardedintroPanel = resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel");

      this._modifierAssets.boost = [
        resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:collectBoostAsset"),
        resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:devilSymbolBoost"),
        resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:boostDevilAdded"),
        resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:boostDevilInfoText"),
      ];
      this._modifierAssets.multi = [
        resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:multiAsset"),
        resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:devilSymbolMulti"),
        resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:multiDevilAdded"),
        resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:multiDevilInfoText"),
      ];
      this._modifierAssets.respin = [
        resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:respinAsset"),
        resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:devilSymbolRespin"),
        resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:respinDevilAdded"),
        resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:respinDevilInfoText"),
      ];

      this._clickToContinue = resourceManager.get("modifierAwardedPanel:modifierAwardedIntroPanel:continueContainer");
      gsap.to(this._clickToContinue, {
        duration: 0.8,
        pixi: { scaleX: 0.92, scaleY: 0.92 },
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      });

      this._pressStartBox = resourceManager.get("modifierAwardedContinueBox");

      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;
    }

    /**
     * Scale in panel for the necessary modifier
     */
    async awardBonus(modifierAwarded) {
      this._modifierAwardedCompletePromise = new Promise((res) => {
        this._modifierAwardedCompleteResolve = res;
      });

      this._currentBoost = modifierAwarded;
      this._modifierAssets[modifierAwarded].forEach((asset) => (asset.visible = true));
      this._modifierAwardedintroPanel.alpha = 1;
      this._panelShowing = true;
      musicManager.popupEnter();
      await gsap.fromTo(this._modifierAwardedintroPanel.scale, { x: 0.2, y: 0.2 }, { x: 0.8, y: 0.8, duration: 0.5 });
      this.setActive();

      await this._modifierAwardedCompletePromise;
      this._panelShowing = false;
    }

    /**
     * scale out panel
     */
    async scaleOutPanel() {
      this._modifierAwardedCompleteResolve();

      musicManager.popupExit();
      gsap.to(this._modifierAwardedintroPanel.scale, { x: 0.2, y: 0.2, duration: 0.5 });
      await gsap.to(this._modifierAwardedintroPanel, { alpha: 0, duration: 0.5 });
      this._modifierAssets[this._currentBoost].forEach((asset) => (asset.visible = false));
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;
      gameController.reelBorderFire.switchColour();
    }

    /**
     * Handle orientation change
     * @param {boolean} isLandscape
     */
    _orientationChange(isLandscape) {
      if (this._panelShowing) {
        this._modifierAssets[this._currentBoost].forEach((asset) => (asset.visible = true));
        this._modifierAwardedintroPanel.alpha = 1;
        this._modifierAwardedintroPanel.scale.set(0.8);
      }
    }
  }

  resourceManager.registerObjectType(
    "modifierAwardedPanel",
    () => new ModifierAwardedPanel(),
    () => {},
    () => []
  );
})();
